import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { SellingCompanyWarehouse } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyWarehouseService extends TmsWebBaseEditCreateService<
  SellingCompanyWarehouse,
  SellingCompanyWarehouse
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SellingCompanyWarehouse', $localize`Selling Company Warehouse`, httpService, notificationService);
  }

  getForSellingCompany(id: string): Observable<SellingCompanyWarehouse[]> {
    return this.httpService.get<SellingCompanyWarehouse[]>(`${this.apiUrl}/GetForSellingCompany?id=${id}`);
  }
}
